"use strict";

exports.__esModule = true;

var CertificateParser_1 = require("../CertificateParser");

var shared_1 = require("../shared");

var Errors_1 = require("../../common/Errors");

var _memoize = require("lodash/memoize");

var Log_1 = require("../../common/Log");

var constants_1 = require("../constants");

var utils_1 = require("../utils");

var Metrics_1 = require("../../common/Metrics");

var ErrorCodes;

(function (ErrorCodes) {
  ErrorCodes["ParsingError"] = "ParsingError";
})(ErrorCodes = exports.ErrorCodes || (exports.ErrorCodes = {}));

var subjectRDNReplacementScheme = [{
  from: 'OID.1.2.840.113549.1.9.2',
  to: 'UN'
}, {
  from: 'UnstructuredName',
  to: 'UN'
}, {
  from: 'OID.1.2.643.3.131.1.1',
  to: 'ИНН'
}, {
  from: 'INN',
  to: 'ИНН'
}, {
  from: 'OID.1.2.643.100.1',
  to: 'ОГРН'
}, {
  from: 'OGRN',
  to: 'ОГРН'
}, {
  from: 'OID.1.2.643.100.5',
  to: 'ОГРНИП'
}, {
  from: 'OGRNIP',
  to: 'ОГРНИП'
}];

var Certificate =
/** @class */
function () {
  function Certificate(c) {
    var _this = this;

    this.subjectRDN = {};
    this.issuerRDN = {};
    this.log = Log_1.LogManager.getLog(constants_1.LOG_PREFIX + "ToolboxCertificate");
    this.metrics = Metrics_1.MetricsManager.getMetrics(constants_1.METRICS_CATEGORY);

    this.type = function () {
      return shared_1.CertificateType.Iron;
    };

    this.thumbprint = function () {
      var binary = _this.rawCertificate.getHash();

      var thumbprint = binary.toHexString().toLowerCase();
      binary.close();
      return thumbprint;
    };

    this.inn = function () {
      return CertificateParser_1["default"].inn(_this.subjectRDN);
    };

    this.kpp = function () {
      return CertificateParser_1["default"].kpp(_this.subjectRDN, _this.subjectType);
    };

    this.issuer = function () {
      return CertificateParser_1["default"].issuer(_this.issuerRDN);
    };

    this.owner = function () {
      return CertificateParser_1["default"].owner(_this.subjectRDN);
    };

    this.organizationName = function () {
      return CertificateParser_1["default"].organizationName(_this.subjectRDN, _this.subjectType);
    };

    this.validTo = function () {
      return _this.rawCertificate.getValidTo();
    };

    this.validFrom = function () {
      return _this.rawCertificate.getValidFrom();
    };

    this.serialNumber = function () {
      var binary = _this.rawCertificate.getSerialNumber();

      var serialNumber = binary.toHexString().toLowerCase();
      binary.close();
      return serialNumber;
    };

    this.publicKeyLength = function () {
      var length;

      if (_this.rawCertificate.getPublicKeyLength) {
        try {
          length = _this.rawCertificate.getPublicKeyLength();
        } catch (e) {
          _this.log.error("Can't get public key length. " + e.message);
        }
      }

      return length;
    };
    /**
     * getPublicKeyAlgorithm появился начиная с версии 2.9.5.23.
     * Для более ранних версий можно поискать OID алгоритма в контенте сертификата.
     */


    this.publicKeyAlgorithm = function () {
      var algorithm;

      if (_this.rawCertificate.getPublicKeyAlgorithm) {
        try {
          algorithm = _this.rawCertificate.getPublicKeyAlgorithm();
        } catch (e) {
          _this.log.error("Can't get public key algorithm. " + e.message);
        }
      }

      if (algorithm === undefined) {
        var binary = _this.rawCertificate.getContent();

        var hex = binary.toHexString().toLowerCase();
        binary.close();
        algorithm = utils_1.getPublicKeyAlgorithm(hex);
      }

      return algorithm;
    };

    this.hasPrivateKey = function () {
      return _this.rawCertificate.hasPrivateKey();
    };

    this.isQualified = function () {
      var ext = _this.rawCertificate.getExtensions();

      return !!(ext && ext.keyUsages && ext.policies && ext[shared_1.OIDs.XCN_OID_CRL_DIST_POINTS] && ext[shared_1.OIDs.XCN_OID_AUTHORITY_KEY_IDENTIFIER2] && ext[shared_1.OIDs.OWNER_DS_TOOL] && ext[shared_1.OIDs.UC_ISSUER_DS_TOOL]);
    };

    this.isCloud = function () {
      return CertificateParser_1["default"].isCloud(_this.rawCertificate.getExtensions());
    };

    this.toBase64 = function () {
      var binary = _this.rawCertificate.getContent();

      var base64 = binary.toBase64();
      binary.close();
      return base64;
    };

    this.cryptoProvider = function () {
      return undefined;
    };

    this.containerInfo = function () {
      return undefined;
    };

    this.licenseBuiltin = function () {
      return CertificateParser_1["default"].licenseBuiltin(_this.rawCertificate.getExtensions());
    };

    this.ogrn = function () {
      return _this.subjectRDN['ОГРН'] || _this.subjectRDN['ОГРНИП'] || '';
    };

    this.extensions = function () {
      return _this.rawCertificate.getExtensions();
    };

    this.raw = function () {
      return _this.rawCertificate;
    };

    this.memoizeCertProps = function () {
      _this.thumbprint = _memoize(_this.thumbprint);
      _this.inn = _memoize(_this.inn);
      _this.kpp = _memoize(_this.kpp);
      _this.issuer = _memoize(_this.issuer);
      _this.owner = _memoize(_this.owner);
      _this.organizationName = _memoize(_this.organizationName);
      _this.validTo = _memoize(_this.validTo);
      _this.validFrom = _memoize(_this.validFrom);
      _this.serialNumber = _memoize(_this.serialNumber);
      _this.hasPrivateKey = _memoize(_this.hasPrivateKey);
      _this.isQualified = _memoize(_this.isQualified);
      _this.isCloud = _memoize(_this.isCloud);
      _this.toBase64 = _memoize(_this.toBase64);
      _this.cryptoProvider = _memoize(_this.cryptoProvider);
      _this.containerInfo = _memoize(_this.containerInfo);
      _this.licenseBuiltin = _memoize(_this.licenseBuiltin);
      _this.ogrn = _memoize(_this.ogrn);
      _this.publicKeyLength = _memoize(_this.publicKeyLength);
      _this.publicKeyAlgorithm = _memoize(_this.publicKeyAlgorithm);
    };

    this.savePritableVersion = function () {
      _this.printableCertificate = {
        type: _this.type(),
        thumbprint: _this.thumbprint(),
        inn: _this.inn(),
        kpp: _this.kpp(),
        issuer: _this.issuer(),
        owner: _this.owner(),
        organizationName: _this.organizationName(),
        validTo: _this.validTo(),
        validFrom: _this.validFrom(),
        serialNumber: _this.serialNumber(),
        hasPrivateKey: _this.hasPrivateKey(),
        isQualified: _this.isQualified(),
        isCloud: _this.isCloud(),
        cryptoProvider: _this.cryptoProvider(),
        licenseBuiltin: _this.licenseBuiltin(),
        ogrn: _this.ogrn(),
        toBase64: _this.toBase64(),
        containerInfo: _this.containerInfo(),
        publicKeyLength: _this.publicKeyLength(),
        publicKeyAlgorithm: undefined,
        extensions: _this.extensions()
      };
    };

    var thumbprint;

    try {
      this.rawCertificate = c;
      thumbprint = this.thumbprint();
      this.subjectRDN = CertificateParser_1["default"].replaceRDNKeys(c.getSubject().parse(), subjectRDNReplacementScheme);
      this.issuerRDN = c.getIssuer().parse();
      this.subjectType = CertificateParser_1["default"].subjectType(this.subjectRDN);
      this.memoizeCertProps();
      this.savePritableVersion();
    } catch (error) {
      var message = "Certificate parse error: " + error.message;
      this.log.error(message);
      this.metrics.trackEventNC('ToolboxCertificate', 'Error', {
        code: ErrorCodes.ParsingError,
        thumbprint: thumbprint || 'empty',
        message: message
      });
      throw new Errors_1.CommonError(message, null, ErrorCodes.ParsingError);
    }
  }

  return Certificate;
}();

exports["default"] = Certificate;